<template>
    <div class="index">
        <!-- banner -->
        <slider :sliderData="sliderData"></slider>
        <!-- 部门简介 -->
        <div class="bmjj margin-t50">
          <div class="w1200">
            <div class="bmjjTitle">
                <p>图书馆概况</p>
                <span>LIBRARY OVERVIEW</span>
                <em></em>
            </div>
            <div class="jjBox flexDiv">
              <p class="jjImg imgBox"><img :src="bmjj.Photo" alt=""><span></span></p>
              <div class="details"><div class="gkVal" v-html="bmjj.Info"></div></div>
            </div>
            <a :href="bmjj.ID" class="more"></a>
          </div>
        </div>
        <!-- 无图新闻 -->
        <div class="wutuDiv">
          <div class="w1200 flexDiv">
            <ggxx :ggxxList='ggxxList' moreLink = "/list.html?HType=2&CId=5691"></ggxx>
            <div class="rgzn">
              <div class="titleBox flexDiv">
              	<p>
              		<em>入馆指南</em>
              		<span>ENTRY GUIDE</span>
              	</p>
                <a href="" class="moreBtn wow zoomIn" data-wow-delay="0.3s"><i></i></a>
              </div>
              <ul>
                <li>
                  <a href="./list.html?HType=1&CId=6358">
                    <span>开放时间</span>
                    <em>OPENING HOURS</em>
                  </a>
                </li>
                <li>
                  <a href="./list.html?HType=2&CId=6359">
                    <span>新生导读</span>
                    <em>FRESHMAN GUIDE</em>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import '../assets/css/index.css';
import slider from '@/components/slider';
import ggxx from '@/components/ggxx';
export default {
    name:'index',
    components:{
        slider,
        ggxx
    },
    props:{
      moreLink: {
         type: String,
         default: ''
      }
    },
    data(){
        return{
            baseUrl:'this.baseUrl',
            sliderData:[],
            zcppList:[]
        }
    },
    created(){
        this.$root.$children['0'].$children['0'].menuListOne.forEach(element =>element.On = false)
        this.sliderData = this.Base.GetFilesInfoByCid(5693,1,'',6,1); //banner
        this.bmjj = this.Base.GetSinglePageInfoByCid(5687);
        this.ggxxList = this.Base.GetNewsInfoByCid(5691,false,1,'',4);
        // console.log(this.bmjj)
        // console.log(this.bmjj.Photo)
    }

}
</script>



// WEBPACK FOOTER //
// src/components/index.vue